// client/src/components/common/Pagination.js
import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const Pagination = ({ itemsPerPage, totalItems, currentPage, onPageChange }) => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    if (totalItems === 0 || totalPages <= 1) return null;

    const startRecord = (currentPage - 1) * itemsPerPage + 1;
    const endRecord = Math.min(currentPage * itemsPerPage, totalItems);

    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, currentPage + 2);

    if (totalPages <= 5) {
        startPage = 1;
        endPage = totalPages;
    } else if (currentPage <= 3) {
        startPage = 1;
        endPage = 5;
    } else if (currentPage + 2 >= totalPages) {
        startPage = totalPages - 4;
        endPage = totalPages;
    }

    const pageNumbers = [];
    for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);

    return (
        <div className="pagination-wrapper">
            <p className="pagination-info">
                {startRecord}–{endRecord} de {totalItems} registro{totalItems !== 1 ? 's' : ''} &bull; Página {currentPage} de {totalPages}
            </p>

            <nav className="pagination-nav" aria-label="Paginação">
                <button
                    className="pagination-btn"
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    aria-label="Página anterior"
                >
                    <ChevronLeft size={15}/>
                </button>

                {startPage > 1 && (
                    <>
                        <button className="pagination-btn" onClick={() => onPageChange(1)}>1</button>
                        {startPage > 2 && <span className="pagination-ellipsis">…</span>}
                    </>
                )}

                {pageNumbers.map(n => (
                    <button
                        key={n}
                        className={`pagination-btn${currentPage === n ? ' is-active' : ''}`}
                        onClick={() => onPageChange(n)}
                    >
                        {n}
                    </button>
                ))}

                {endPage < totalPages && (
                    <>
                        {endPage < totalPages - 1 && <span className="pagination-ellipsis">…</span>}
                        <button className="pagination-btn" onClick={() => onPageChange(totalPages)}>{totalPages}</button>
                    </>
                )}

                <button
                    className="pagination-btn"
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    aria-label="Próxima página"
                >
                    <ChevronRight size={15}/>
                </button>
            </nav>
        </div>
    );
};

export default Pagination;
